import Vue from 'vue';

import TabsInstaller from './index.js';

Vue.use(TabsInstaller);
